var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    strokeDasharray: 3,
    cx: 18,
    cy: 18,
    r: 17.5,
    className: "cu-stroke cu-stroke-dasharray",
    stroke: "#979797",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 9.9,
    width: 1,
    height: 16.2,
    rx: 0.5,
    className: "cu-fill",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11.3h11.6l-3 3.5 3 3.6H14z",
    className: "cu-stroke",
    stroke: "#979797",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.2723e724276305501525e19559cf2e41.svg";
export { ForwardRef as ReactComponent };